export enum UserType {
  'practitioner',
  'technician'
}
